import React, { useMemo } from 'react';
import { ProductionPiece } from 'app/models/ProductionPiece';
import { Workstation } from 'app/containers/OrderDetails/types';
import { useSelector } from 'react-redux';
import { selectDrawerComposition } from 'app/containers/OrderDetails/HeaderOrderDetails/PrintOrder/selectors';
import { PartOrder } from 'app/models/PartOrder';
import PickingPageView from 'shared/printing/pickingPresentation/PickingPageView';
import { createTextLineCounter } from 'shared/printing/pickingPresentation';
import { PickingOrderStrategy } from 'shared/printing/pickingOrder';

interface Props {
  order: PartOrder;
  pieces: ProductionPiece[];
  workstation: Workstation;
  trolleyName?: string;
  drawerId?: number;
  pickingOrderStrategy: PickingOrderStrategy;
}

const PickingPage = ({
  order,
  pieces,
  workstation,
  trolleyName,
  drawerId,
  pickingOrderStrategy,
}: Props) => {
  const drawerPieces = useSelector(selectDrawerComposition(drawerId));
  const countTextLines = useMemo(() => createTextLineCounter('dom'), []);

  return (
    <PickingPageView
      order={order}
      pieces={pieces}
      workstation={workstation}
      trolleyName={trolleyName}
      drawerPieces={drawerPieces}
      countTextLines={countTextLines}
      pickingOrderStrategy={pickingOrderStrategy}
    />
  );
};

export default PickingPage;
